import { render } from "./LoginComponent.vue?vue&type=template&id=a30d5c6e&scoped=true"
import script from "./LoginComponent.vue?vue&type=script&lang=js"
export * from "./LoginComponent.vue?vue&type=script&lang=js"

import "./LoginComponent.vue?vue&type=style&index=0&id=a30d5c6e&scoped=true&lang=css"

import exportComponent from "C:\\repo\\dashboard-project-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a30d5c6e"]])

export default __exports__